import React, {
  FunctionComponent, useCallback, useEffect, useMemo, useState,
} from 'react';
import { createB2BLead } from '../../../services/leads/leads';
import B2BContactForm, { B2BContactFormModel } from '../../components/b2b-contact-form/B2BContactForm';
import { GoogleMapsContext } from '../../contexts/google-map-context/GoogleMapsContext';
import withNextConfig from '../../hocs/withNextConfig/withNextConfig';
import { getAutoCompleteSessionToken } from '../../services/geo/geo';

export interface CreateB2BLeadProps {
  config: {
    MAPS: {
      apiKey: string,
    },
  },
}

export const ERROR_MESSAGE = 'Errore durante l\'invio del form';
export const SUCCESS_MESSAGE = 'Form inviato correttamente!';

export const CreateB2BLead: FunctionComponent<CreateB2BLeadProps> = ({
  config,
}) => {
  const { MAPS: { apiKey } } = config;
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [successMessage, setSuccessMessage] = useState(undefined);
  const [errorMessage, setErrorMessage] = useState(undefined);
  const [sessionToken, setSessionToken] = useState<google.maps.places.AutocompleteSessionToken>();

  const googleMapsContext = useMemo(() => ({
    apiKey,
    sessionToken,
  }), [apiKey, sessionToken]);

  // @TODO This could be extracted into a custom hook that uses useSWR
  useEffect(() => {
    async function fetch() {
      setIsLoading(true);

      try {
        const token = await getAutoCompleteSessionToken(apiKey);
        setSessionToken(token);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }

      setIsLoading(false);
    }
    fetch();
  }, [apiKey]);

  const onSubmit = useCallback(async (values: B2BContactFormModel) => {
    setErrorMessage(undefined);
    setIsLoading(true);

    try {
      await createB2BLead(values);
      setSuccessMessage(SUCCESS_MESSAGE);
      setIsDisabled(true);
    } catch (err) {
      setErrorMessage(ERROR_MESSAGE);
    }

    setIsLoading(false);
  }, []);

  return (
    <GoogleMapsContext.Provider value={googleMapsContext}>
      <B2BContactForm
        loading={isLoading}
        disabled={isDisabled}
        successMessage={successMessage}
        errorMessage={errorMessage}
        onSubmit={onSubmit}
      />
    </GoogleMapsContext.Provider>
  );
};

export default withNextConfig(CreateB2BLead);
